import React from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";

import { DEFAULT_NOT_AUTH_PATH } from "const";
import RouteWithLayout from "./RouteWithLayout";


const AuthRoute = ({ auth, authInfo, permissions, ...props }) => {
    if (!auth) {
        return <Redirect to={DEFAULT_NOT_AUTH_PATH} />;
    }

    return <RouteWithLayout {...props} />;
};

const mapState = ({ auth }) => ({
    auth: auth.auth,
    authInfo: auth.authInfo,
    permissions: auth.permissions,
    lang: auth.lang,
    rtl: auth.rtl,
});

export default connect(mapState)(AuthRoute);